'use client';
import { isRequest } from '../../utils/guards.js';

var getInputCredentials = function(input) {
    return isRequest(input) && "credentials" in Request.prototype ? input.credentials : undefined;
};

export { getInputCredentials };
